module.exports = __webpack_public_path__ + "img/3-4.87697fee.jpg";